var Listener = /*#__PURE__*/function () {
  function Listener() {
    this.listeners = void 0;
    this.listeners = [];
  }

  var _proto = Listener.prototype;

  _proto.listen = function listen(callback) {
    var _this = this;

    this.listeners.push(callback);
    return function () {
      return _this.unlisten(callback);
    };
  };

  _proto.unlisten = function unlisten(callback) {
    var index = this.listeners.indexOf(callback);

    if (index >= 0) {
      this.listeners.splice(index, 1);
    }
  };

  _proto.notify = function notify(fn) {
    this.listeners.forEach(function (l) {
      try {
        fn(l);
      } catch (e) {
        if (console && console.error) {
          console.error(e);
        }
      }
    });
  };

  return Listener;
}();

export { Listener };
//# sourceMappingURL=Listener.esm.js.map
